import { ModuleConstants } from '../../common/constant/modules';
import { ModuleRoutesComponentInterface } from '../../common/routes/types';
import { generateImage } from '../../common/utils/generateImage';
import { ComponentsMap } from './components';
import { ScreenNames } from './screens';
import { RouteConstantsInterface } from './types';

export enum RouteConstantEnums {
  JOB_REQUISITIONS,
  JOB_REQUISITIONS_VIEW,
  CANDIDATE,
  CANDIDATE_APPLICATION_STATUS,
  // CANDIDATE_INTERVIEW_STATUS,
  CANDIDATE_ONBOARDING,
  INTERVIEW_CANDIDATE_VIEW,
  CANDIDATE_PRE_ONBOARDING,
}

export const RouteConstants: RouteConstantsInterface = {
  JOB_REQUISITIONS: '/job-requisitions',
  JOB_REQUISITIONS_VIEW: '/job-requisitions/:jobRequisitionId',
  CANDIDATE: '/candidate',
  CANDIDATE_APPLICATION_STATUS: '/candidate/application-status',
  // CANDIDATE_INTERVIEW_STATUS: '/candidate/interview-status',
  INTERVIEW_CANDIDATE_VIEW: '/candidate/interview/:leadId/:selectedId',
  CANDIDATE_ONBOARDING: '/candidate/onboarding',
  CANDIDATE_PRE_ONBOARDING: '/candidate/pre-onboarding',
};

const getHiringAndLeadsModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.JOB_REQUISITION_MODULE,
      route: RouteConstants.JOB_REQUISITIONS,
      title: ScreenNames.JOB_REQUISITIONS,
      icon: generateImage({
        noScale: true,
        name: 'briefcase',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.JOB_REQUISITIONS,
    },
    {
      id: ModuleConstants.JOB_REQUISITION_CANDIDATE_MODULE,
      route: RouteConstants.JOB_REQUISITIONS_VIEW,
      title: ScreenNames.JOB_REQUISITIONS_VIEW,
      icon: generateImage({
        noScale: true,
        name: 'user',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      sidebarVisibility: false,
      component: ComponentsMap.JOB_REQUISITIONS_VIEW,
    },
    {
      id: ModuleConstants.CANDIDATE_MODULE,
      route: RouteConstants.CANDIDATE,
      title: ScreenNames.CANDIDATE,
      icon: generateImage({
        noScale: true,
        name: 'users',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.APPLICATION_STATUS_MODULE,
          route: RouteConstants.CANDIDATE_APPLICATION_STATUS,
          title: ScreenNames.CANDIDATE_APPLICATION_STATUS,
          component: ComponentsMap.CANDIDATE_APPLICATION_STATUS,
          children: [
            {
              id: ModuleConstants.CANDIDATE_REVIEW_MODULE,
              route: RouteConstants.INTERVIEW_CANDIDATE_VIEW,
              title: ScreenNames.INTERVIEW_CANDIDATE_VIEW,
              component: ComponentsMap.INTERVIEW_CANDIDATE_VIEW,
              sidebarVisibility: false,
            },
          ],
        },
        {
          id: ModuleConstants.CANDIDATE_PRE_ONBOARDING,
          route: RouteConstants.CANDIDATE_PRE_ONBOARDING,
          title: ScreenNames.CANDIDATE_PRE_ONBOARDING,
          component: ComponentsMap.CANDIDATE_PRE_ONBOARDING,
        },
        // {
        //   id: ModuleConstants.PUBLIC_MODULE_ID,
        //   route: RouteConstants.CANDIDATE_INTERVIEW_STATUS,
        //   title: ScreenNames.CANDIDATE_INTERVIEW_STATUS,
        //   component: ComponentsMap.CANDIDATE_INTERVIEW_STATUS,
        //   children: [
        //     {
        //       id: ModuleConstants.PUBLIC_MODULE_ID,
        //       route: RouteConstants.INTERVIEW_CANDIDATE_VIEW,
        //       title: ScreenNames.INTERVIEW_CANDIDATE_VIEW,
        //       component: ComponentsMap.INTERVIEW_CANDIDATE_VIEW,
        //       sidebarVisibility: false,
        //     },
        //   ],
        // },
        {
          id: ModuleConstants.ONBOARDING_TRACKER,
          route: RouteConstants.CANDIDATE_ONBOARDING,
          title: ScreenNames.CANDIDATE_ONBOARDING,
          component: ComponentsMap.CANDIDATE_ONBOARDING,
        },
      ],
    },
  ];
};

export default getHiringAndLeadsModuleRoutes;
